import { axiosInstance } from "@/services/axiosInstance";

export const PayoutTypeResource = {
 
  getKeyValue : (parametros) => {
    return axiosInstance.get(
      'v1/payouttype/keyvalue',
      {
        params: parametros
      }
    )

  },

  update : (parametros) => {
    return axiosInstance.put('v1/payouttype', parametros)
  },
 
};